<template>
  <div class="sm:hidden h-full ">
    <EventsListener @color_theme_changed="$forceUpdate" />
    <RoundFilterUtils />
    <Svgs />
    <SplashComponent v-if="!canGoIntoApp" />
    <div
      v-else
      class="w-full h-full opacity-0 hidden"
      :class="{ '!block !opacity-100': canGoIntoApp }"
    >
      <!-- <client-only> -->
      <div class="h-full w-full">
        <router-view />
      </div>
      <div :key="pageContentKey">
        <CouponDetails />
        <VipSubscription />
        <MatchDetails />
        <MatchFiltersComponent />
        <TransactionLauncher />
        <TransactionDetailsComponent />
        <PreferencesSetter />
        <PaymentLinkShower />
        <AppRatting />
        <MatchList />
        <AffiliationShareComponent />
        <BookmakerAccountValidator />
        <TourGuide />
        <PromptModal />
        <LinkOpener />
        <ChoiceModal />
        <LoadingPromptModal />
        <Chat />
      </div>
      <!-- </client-only> -->
    </div>

    <ToastNotification />

    <EventListener
      :events="['login_done', 'registration_done', 'user_connected']"
      @login_done="deleteReferralCode"
      @registration_done="deleteReferralCode"
      @user_connected="deleteReferralCode"
    />
    <!-- <PwaInstallation/> -->
  </div>

  <div
    class="hidden sm:flex lg:hidden w-full h-full items-center justify-center flex-col"
  >
    <div class="h-[60vh]">
      <img
        class="w-full h-full object-contain"
        src="@/assets/images/all/rotateScreanPortrait.png"
        alt=""
      />
    </div>
    <div class="text-3xl font-bold text-center">
      Veuillez tourner l'écran en mode portrait
    </div>
    <div class=" ">ou passer sur un téléphone portable</div>
  </div>
  <TvsModal class="lg:hidden" />
  <div class="hidden lg:flex h-full items-center bg-white">
    <section id="download">
      <div class="px-2 md:px-8">
        <div
          class="rounded-[3rem] md:rounded-[6rem] bg-[#121212] py-24 relative"
        >
          <div class="absolute w-full h-full pointer-events-none opacity-5">
            <img
              src="@/assets/images/backgrounds/patern2.svg"
              alt=""
              class="w-full h-full object-cover"
            />
          </div>
          <div
            class="grid md:grid-cols-2 items-center gap-12 md:gap-0 px-8 md:px-32 relative"
          >
            <div>
              <div
                class="text-4xl md:text-5xl font-bold text-white leading-[1.1em]"
              >
                Dépots et retraits ultra-rapides & sécurisés de vos Bookmakers
              </div>
              <div class="py-4"></div>
              <div>
                <div class="relative md:w-max text-white">
                  <div>&bull; Scannez le code qr Avec Votre téléphone</div>
                  <div
                    class="absolute top-3 w-[7rem] md:w-[8rem] right-0 md:left-[120%]"
                  >
                    <img
                      src="@/assets/images/arrow-white.svg"
                      class="-scale-y-100"
                      alt=""
                    />
                    <div class="font-bold text-right rotate-[-12deg]">
                      Scannez !
                    </div>
                  </div>
                </div>
                <div class="relative text-white">
                  &bull; Téléchargez l'application sur notre site web
                </div>
                <div class="relative text-white">
                  &bull; Inscrivez-vous et faites vos opérations
                </div>
                <div class="py-6"></div>
                <div class="relative max-w-[30rem]">
                  <div class="h-[40vh]">
                    <img
                      class="h-full rounded-2xl overflow-hidden"
                      src="@/assets/images/downloadAnimation/qrcode2.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="pointer-events-none downloadPhoneContainer h-[60svh] md:h-[60svh] flex items-center justify-center relative scale-[1.3]"
            >
              <div class="w-full h-full absolute phoneAnimationHand">
                <img
                  src="@/assets/images/downloadAnimation/hand2.webp"
                  alt=""
                  class="w-full h-full object-contain"
                />
              </div>
              <div class="w-full h-full absolute phoneAimationPhone">
                <img
                  src="@/assets/images/downloadAnimation/phone.webp"
                  alt=""
                  class="w-full h-full object-contain"
                />
              </div>
              <div class="w-full h-full absolute phoneAnimationHand">
                <img
                  src="@/assets/images/downloadAnimation/hand2Inc.webp"
                  alt=""
                  class="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AppRatting from './components/appComponent/AppRatting.vue'
import LinkOpener from './components/appComponent/LinkOpener.vue'
import PwaInstallation from './components/appComponent/PwaInstallation.vue'
import SplashComponent from './components/appComponent/SplashComponent.vue'
import TourGuide from './components/appComponent/TourGuide.vue'
import PreferencesSetter from './components/appData/PreferencesSetter.vue'
import PaymentLinkShower from './components/transaction/PaymentLinkShower.vue'
import TransactionDetailsComponent from './components/transaction/TransactionDetailsComponent.vue'
import ChoiceModal from './components/utils/ChoiceModal.vue'
import LoadingPromptModal from './components/utils/LoadingPromptModal.vue'
import PromptModal from './components/utils/PromptModal.vue'
import ToastNotification from './components/utils/ToastNotification.vue'
import BookmakerAccountValidator from './components/appData/BookmakerAccountValidator.vue'
import MatchList from './components/appData/MatchList.vue'
import Chat from './components/appData/Chat.vue'
import RoundFilterUtils from './components/utils/RoundFilterUtils.vue'
import CouponDetails from './components/appData/CouponDetails.vue'
import MatchDetails from './components/appData/MatchDetails.vue'
import MatchFiltersComponent from './components/appData/MatchFiltersComponent.vue'
import TransactionLauncher from './components/transaction/transactionLaunch/TransactionLauncher.vue'
import Svgs from './components/utils/Svgs.vue'
import VipSubscription from './components/appData/VipSubscription.vue'
import AffiliationShareComponent from './components/appData/affiliation/AffiliationShareComponent.vue'
import EventListener from './components/utils/EventListener.vue'
import TvsModal from './components/appData/tv/TvsModal.vue'

export default {
  name: 'App',
  metaInfo: {
    link: [],
  },
  components: {
    PwaInstallation,
    EventListener,
    PreferencesSetter,
    PromptModal,
    ToastNotification,
    TransactionDetailsComponent,
    SplashComponent,
    LoadingPromptModal,
    ChoiceModal,
    LinkOpener,
    AppRatting,
    TourGuide,
    PaymentLinkShower,
    AffiliationShareComponent,
    BookmakerAccountValidator,
    MatchList,
    Chat,
    RoundFilterUtils,
    CouponDetails,
    MatchDetails,
    MatchFiltersComponent,
    TransactionLauncher,
    Svgs,
    VipSubscription,
    TvsModal,
  },
  data() {
    return {
      pageContentKey: 'initial',
      appInitialized: false,
      pages: [
        {
          path: '/home',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
        {
          path: '/subscriptions',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
        {
          path: '/acceptnotification',
          requirements: ['appUpToDate', 'userConnected'],
          redirectTo: ['/updateavailable', '/welcome'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
        {
          path: '/login',
          requirements: ['appUpToDate', 'userNotConnected'],
          redirectTo: ['/updateavailable', '/home'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
        {
          path: '/register',
          requirements: ['appUpToDate', 'userNotConnected'],
          redirectTo: ['/updateavailable', '/home'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
        {
          path: '/registerAfterSubscription',
          requirements: ['appUpToDate'],
          redirectTo: ['/updateavailable'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
        {
          path: '/welcome',
          requirements: ['appUpToDate', 'userNotConnected'],
          redirectTo: ['/updateavailable', '/home'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
          bottomNavColor: {
            '': '#4b4ced',
            '#bottomsheet': '#4b4ced',
            '#modalvisible': '#4b4ced',
            '#tourguide': '#4b4ced',
            '#chat': '#4b4ced',
          },
        },
        {
          path: '/updateavailable',
          requirements: ['appNotUpToDate'],
          redirectTo: ['/home'],
          themeColor: {
            '': '#242c3b',
            '#bottomsheet': '#181E29',
            '#modalvisible': '#181E29',
            '#tourguide': '#181E29',
            '#chat': '#fff',
          },
        },
      ],
      userTheme: 'light',
    }
  },
  beforeMount() {
    // this.$router.push({ path: "/", replace: true }).catch(() => {});
  },
  async mounted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    this.$Events.dispatchEvent('app_initialized')
    setTimeout(() => {
      this.$Events.dispatchEvent('app_initialized')
    }, 500)
    await this.initializeApp()
    this.initListeners()
    this.loadLottiePlayer()
    this.tryEnableLogs()
  },
  beforeUnmount() {},
  methods: {
    tryEnableLogs() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      if (this.$router?.query?.enableLogs) window.console = window.realConsole
    },
    async initializeApp() {
      this.saveReferralCode()
      await this.$router.push('/').catch(e => {})
      await this.$router.push('/#initiating').catch(e => {})
      const userConnected = this.$QuickStorage.getStored('user_connected')
      if (userConnected) this.listenWorkerInitiated()
      await this.handleRoute()
      setTimeout(() => {
        this.appInitialized = true
        this.handleRoute()
      }, 1000)
      try {
        if (window.registerAfterSubscription)
          this.$router.push(window.registerAfterSubscriptionPath)
        else if (window.directRegister) this.$router.push('/register')
      } catch (error) {}
    },
    saveReferralCode() {
      const referralCode = window.referralCode
      if (!referralCode) return
      this.$QuickStorage.storeData('referralCode', referralCode)
    },
    async handleRoute(newRoute = this.$route) {
      let page = this.pages.find(page => page.path == newRoute.path)
      if (!page) page = this.pages[0]

      this.resetThemeColor(page)
      let requirementNotMetIndex = -1
      await Promise.all(
        page.requirements.map(async (requirement, index) => {
          if (requirementNotMetIndex !== -1) return
          if (await this.requirementMet(requirement)) return
          requirementNotMetIndex = index
          return
        }),
      )
      const redirection = page.redirectTo[requirementNotMetIndex]
      if (redirection) {
        await this.$router.push(redirection).catch(e => {})
      } else if (page.path !== newRoute.path) {
        await this.$router.push(page.path).catch(e => {})
      }
    },
    async requirementMet(requirement) {
      if (requirement == 'userConnected') {
        const userConnected = this.$QuickStorage.getStored('user_connected')
        return userConnected
      } else if (requirement == 'userNotConnected') {
        const userConnected = this.$QuickStorage.getStored('user_connected')
        return !userConnected
      } else if (requirement == 'appUpToDate') {
        return await this.appIsUpToDate()
      } else if (requirement == 'appNotUpToDate') {
        return !(await this.appIsUpToDate())
      }
    },
    async appIsUpToDate() {
      if (!window.isIframe) return true
      const appVersionData = await this.$Events.sendDataRequestResolve(
        'andoidApkVersion',
        {},
        3000,
      )
      console.log('check is up to date')
      if (!appVersionData?.version) return true
      return appVersionData?.version >= 6
    },
    listenWorkerInitiated() {
      const reloadingPageTimeoutId = setTimeout(() => {
        window.location.reload()
      }, 10000)
      const pingInterval = setInterval(() => {
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadingPageTimeoutId)
          clearInterval(pingInterval)
          this.checkUserConnectionData()
        })
      }, 1000)
    },

    async checkUserConnectionData() {
      const userData = await this.$Events.sendDataRequestResolve('userData')
      if (!userData?.email) {
        this.$Events.dispatchEvent('logout_requested')
      } else this.$Events.dispatchEvent('user_connected', userData)
      // this.displayedProject = this.$Controller.getDisplayedProject();
    },
    initListeners() {
      this.$Events.handleEvent('login_requested', () => {
        const reloadTimeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadTimeout)
        })
      })
      this.$Events.handleEvent('registration_requested', () => {
        const reloadTimeout = setTimeout(() => {
          window.location.reload()
        }, 3000)
        this.$Events.sendDataRequest('pingWorker', () => {
          clearTimeout(reloadTimeout)
        })
      })
      this.$Events.handleEvent('logout_requested', () => {
        this.$router.push('/login')
        this.$Events.dispatchEvent('clean_all_data_requested')
      })
      this.$Events.handleEvent('logout_done', () => {
        this.$router.push('/login')
      })
      this.$Events.handleEvent(
        'ask_notification_permission_to_user_required',
        () => {
          this.$router.push('/acceptnotification')
        },
      )
      this.$Events.handleEvent('single_transaction_updated', transaction => {
        if (transaction?.status !== 'pending') return
        const paymentUrl = transaction?.paymentUrl
        if (!paymentUrl) return
        if (!window.openedUrls) window.openedUrls = []
        if (window.openedUrls.includes(paymentUrl)) return
        window.open(paymentUrl, '_blank')
        window.openedUrls.push(paymentUrl)
      })
      this.$Events.handleEvent('notification_action_click', notifData => {
        const { data, actionButtonIndex } = notifData
        const matchingAction = (data.actions || [])[actionButtonIndex || 0]
        if (matchingAction.url) {
          window.open(matchingAction.url, '_blank')
        }
        if (matchingAction.recharge1xBet) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: '1xbet',
          })
        }
        if (matchingAction.rechargeBetwinner) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: 'betwinner',
          })
        }
        if (matchingAction.rechargeMelbet) {
          this.$Events.dispatchEvent('service_launching_requested', {
            serviceId: 'melbet',
          })
        }
        if (matchingAction.matchList) {
          this.$Events.dispatchEvent('show_match_list', data.matches)
        }
      })
      this.$Events.handleEvent('deposit_action_requested', () => {
        document.querySelector('#home_navigation_mainHome').click()
        setTimeout(() => {
          this.$Events.dispatchEvent('required_tour_guide', { id: 'service' })
        }, 800)
      })
      this.$Events.handleEvent(
        'vip_subscription_section_display_required',
        () => {
          document.querySelector('#home_navigation_coupons').click()
          setTimeout(() => {
            document.querySelector('#tab_vip').click()
          }, 1000)
        },
      )
      this.$Events.handleEvent('lang_changed', () => {
        // this.key = Date.now();
        this.$forceUpdate()
      })
      this.$Events.handleEvent('color_theme_changed', () => {
        this.key = Date.now()
        // this.$forceUpdate();
      })
      this.$Events.handleEvent('user_not_updated', () => {
        this.$Events.dispatchEvent('toast_notification', {
          body: "Nous n'arrivons pas à mettre à jour les infos de votre compte. Veuillez réessayer",
          type: 'warning',
          title: 'Echec',
        })
      })
      this.$Events.handleEvent('user_data_updated', () => {
        this.$Events.dispatchEvent('toast_notification', {
          body: 'Les infos de votre compte ont été mises à jour correctement',
          type: 'success',
        })
      })
    },
    addPicErrorListener() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      const picsNotWathingError = document.querySelectorAll(
        'img:not([watchimageerror])',
      )
      picsNotWathingError.forEach(pic => {
        pic.addEventListener('error', () => {
          pic.setAttribute('goterror', 'true')
        })
        pic.setAttribute('watchimageerror', 'false')
        pic.setAttribute('onerror', 'this.style.opacity = 0')
      })
    },
    loadLottiePlayer() {
      const scriptSelector = 'script[name="lottieScript"]'
      const lottieScriptAlreadyAdded = document.querySelector(scriptSelector)
      if (lottieScriptAlreadyAdded) return
      const lottieScript = document.createElement('script')
      lottieScript.setAttribute('name', 'lottieScript')
      lottieScript.setAttribute('src', '/plugins/lottie-player.js')
      document.head.appendChild(lottieScript)
    },
    resetThemeColor(pageData) {
      if (!this.appInitialized) return
      const hash = this.$route.hash || ''

      let themeColor = pageData.themeColor['']
      Object.keys(pageData.themeColor).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        themeColor = pageData.themeColor[pageHash]
      })
      console.log(themeColor)
      if (themeColor) {
        this.$Commons.setThemeColor(themeColor)
      }

      let bottomNavColor
      if (pageData.bottomNavColor) pageData.bottomNavColor['']
      Object.keys(pageData.bottomNavColor || {}).forEach(pageHash => {
        const hashMatch = new RegExp(pageHash).test(hash)
        if (!hashMatch) return
        bottomNavColor = pageData.themeColor[pageHash]
      })
      if (bottomNavColor) {
        document.body.style.backgroundColor = bottomNavColor
      } else {
        document.body.style.removeProperty('background-color')
      }
    },

    deleteReferralCode() {
      console.log('will unstore referralCode')
      this.$QuickStorage.removeStored('referralCode')
    },
  },

  computed: {
    canGoIntoApp() {
      return this.appInitialized
    },
  },
  watch: {
    $route: {
      deep: true,
      async handler(newValue, old) {
        this.handleRoute(newValue)
        if (newValue.path !== old.path) {
          this.$QuickStorage.storeAllDbFromMemoryToLocalStorage()
        }
      },
    },
    canGoIntoApp() {
      this.$Events.dispatchEvent('app_initialized')
    },
  },
}
</script>
